import { useQuery } from '@gogame/query';

import { loadFavorites } from '../source/favorites';
import { favoriteFiltersQuery } from './queryKeyFactory';

export const useLoadFavoriteFilters = ({ screen }) => {
  return useQuery(favoriteFiltersQuery.query(screen).all(), (_, { signal }) =>
    loadFavorites({ screen }, { signal })
  );
};
